import fetch from 'cross-fetch'
import { action, makeObservable, observable } from 'mobx'
import uuid from 'react-uuid'
import { set, get, unset, isObject } from 'lodash'

class Store {
  @observable isLoading = false
  @observable isSaving = false
  @observable message = ''

  @observable query = {}

  @observable errorMessage = ''
  @observable errorMessages = {}

  @observable toasts = []

  constructor () {
    makeObservable(this)
  }

  loadOne () {
    throw new Error('Function not implemented')
  }

  loadAll () {
    throw new Error('Function not implemented')
  }

  revert () {
    throw new Error('Function not implemented')
  }

  save () {
    throw new Error('Function not implemented')
  }

  /**
   * @param {string} message
   * @param {''|'success'|"warning"|"error"} [type='']
   * @param {number} [delay=2000] ms
   */
  @action
  addToast (message, type = '', delay = 5000) {
    const toast = {
      id: uuid(),
      type: type ? { [type]: true } : {},
      message: message
    }
    this.toasts.push(toast)
    setTimeout(() => {
      this.removeToast(toast)
    }, delay)
    return toast
  }

  /**
   * Fetch a file and trigger a browser download instead of navigating to it.
   * @param {string} path
   * @param {string} [fallbackFilename='document.pdf']
   */
  async downloadFile (path, fallbackFilename = 'document.pdf') {
    if (process.env.NODE_ENV === 'development') {
      const port = document.location.port ? `:${document.location.port}` : ''
      path = `http://mci.dev.kyoconseil.com${port}${path}`
    }
    const response = await fetch(path, { credentials: 'include' })
    if (!response.ok) {
      throw new Error(`Téléchargement échoué : ${response.status}`)
    }
    const contentType = response.headers.get('Content-Type') || ''
    if (contentType.includes('text/html')) {
      // SPA fallback page served instead of the file: the service is down or the route is wrong
      throw new Error('Téléchargement échoué : réponse invalide du service PDF')
    }
    const blob = await response.blob()
    const disposition = response.headers.get('Content-Disposition') || ''
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
    const filename = match ? decodeURIComponent(match[1]) : fallbackFilename
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(objectUrl)
  }

  @action
  set (name, value) {
    set(this, name, value)
  }

  /**
   * Must not be @action otherwise it breaks
   * @param name
   * @param defaultValue
   * @returns {*}
   */
  get (name, defaultValue) {
    const value = get(this, name)
    if (!value && defaultValue !== undefined) {
      // this.set(name, defaultValue)
      return defaultValue
    }
    return value
  }

  @action
  unset (name) {
    unset(this, name)
  }

  /**
   * Must not be @action otherwise it breaks
   * @param name
   * @returns {undefined|any}
   */
  getErrorMessageField (name) {
    const value = get(this.errorMessages, name)
    if (value) {
      if (isObject(value)) {
        return value[Object.keys(value)[0]]
      } else {
        return value
      }
    } else { return undefined }
  }

  @action
  resetErrorMessageField (name) {
    unset(this.errorMessages, name)
  }

  @action
  clearErrorMessages () {
    this.errorMessage = ''
    this.errorMessages = {}
  }

  @action
  clearError () {
    this.errorMessage = ''
  }

  @action
  removeToast (toast) {
    this.toasts = this.toasts.filter(currentToast => currentToast.id !== toast.id)
  }
}

export default Store
